import React from 'react';
import useClientSideRender from '../../../../hooks/useClientSideRender';

const MainContentSkipLink = () => {
  const { isClient } = useClientSideRender();

  if (isClient) {
    if (document.getElementById('search-page')) {
      return (
        <a className="skip-link hmf-subheader-bold-m hmf-p-xxs hmf-m-xxs" href="#search-page">
          Skip to Main Content
        </a>
      );
    }
    return (
      <a
        className="skip-link hmf-subheader-bold-m hmf-p-xxs hmf-m-xxs"
        href="./#app-container"
        onClick={(event) => {
          event.preventDefault();
          window.location.hash = 'app-container';
        }}>
        Skip to Main Content
      </a>
    );
  }
  return null;
};

export default MainContentSkipLink;
